<template>
  <el-dialog
    :title="chatEmployeeList[0] ? chatEmployeeList[0].corporateName : $t('Employee List')"
    :visible.sync="exhibitorDialogVisible"
    custom-class="chat-dialog-with-exhibitor"
    :before-close="handleClose"
  >
    <div class="member-list" v-if="!inviter && !receivingUser && exhibitorDialogVisible">
      <el-alert
        v-if="inviteType == 'invite'"
        :closable="false"
        type="warning"
        style="padding-left: 8px;font-size: 14px; margin-top: -30px">
        <template slot="title">
          {{ $t('inviteTips') }}
        </template>
      </el-alert>
      <swiper class="swiper" :options="swiperOption">
        <swiper-slide v-for="(item, index) in chatEmployeeList" :key="index">
          <div class="member-item" @click="handleEmployeeClick(item)">
            <img class="item-avatar" :src="item.avatar || defImage('actor')" />
            <div class="item-name">{{ item.name }}</div>
            <div class="item=position">{{ item.position }}</div>
            <!-- <i class="iconfont iconxiaoxi_weixuanzhong iconchat"></i> -->
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </div>

    <div slot="title" v-if="receivingUser && exhibitorDialogVisible">
      <button type="button" class="el-dialog__backbtn" @click="goEmployeeList">
        <i class="chat-title__icon el-icon-arrow-left"></i>
      </button>
      <img class="chat-title__avatar" @click="showCard(receiver)" :src="receiver.avatar || defImage('actor')" />
      <span class="chat-title__name">{{ receiver.name }}</span>
      <span class="chat-title__name">{{ receiver.position }}</span>
      <button type="button" class="el-dialog__headerbtn">
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>
      <div v-if="imInfoCard" class="imInfoCard">
        <p class="text-right"><i @click="closeCard" class="el-icon-close"></i></p>
        <img  class="chat-title__avatar1" :src="imInfo.headImage || defImage('actor')" />
        <p class="font-size-16 p1 word-Wrap">{{ imInfo.name}}</p>
        <p class="font-size-14 p1 word-Wrap">{{ imInfo.post}}</p>
        <p class="font-size-12 p2 word-Wrap">{{ imInfo.corporateName}}</p>
        <p class="font-size-12 p2 word-Wrap">{{ imInfo.countryName}}</p>
      </div>
    </div>

    <ChatDialog v-if="receivingUser && exhibitorDialogVisible" />

    <div slot="title" v-if="inviter && exhibitorDialogVisible" class="invitationClass">
      <div class="invitationBut">
        <button type="button" class="el-dialog__backbtn" @click="goEmployeeList">
          <i class="chat-title__icon el-icon-arrow-left"></i>
        </button>
        <button type="button" class="el-dialog__headerbtn">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </button>
      </div>
      <div class="invitationTitle">
        <div class="invitationTitleTop">{{ $t('You are going to invate') }}</div>
        <div class="invitationTitleBottom">
          {{ $t('with someones invitation', [`${inviter.corporateName} ${inviter.position} ${inviter.name}`]) }}
        </div>
      </div>
    </div>

    <div v-if="inviter && exhibitorDialogVisible" class="invitationConcat">
      <div class="invitationTips">{{ $t('According to the platform analyze') }}</div>
      <!-- <div class="invitationTips">
        {{ $t('Chat now') }}
        <span @click="setReceiverMsg">
          <i class="iconfont iconxiaoxi_weixuanzhong theme-icon-primary-color"></i>
          <span class="invitationTipsSapn">{{ $t('Send message') }}</span>
        </span>
      </div> -->
      <div type="flex" class="text-right" justify="end">
        <el-button size="mini" class="send-btn head-right" @click="handleClose">
          {{ $t('finds.cancel') }}
        </el-button>
        <el-button type="primary" size="mini" class="send-btn head-right" @click="invite(inviter.id, inviter.subscript, inviter.type)">
          {{ $t('confirm') }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { mapState,mapGetters } from 'vuex'
import ChatDialog from '@/components/chat/ChatDialog'
import { inviteOrIM } from '@/utils/function'
import { getUserInfoByEasemob } from '@/api/index'
export default {
  name: 'ChatWithExhibitor',

  props: {
    action: {
      type: String,
      default: 'chat'
    }
  },

  components: {
    ChatDialog
  },

  data() {
    return {
      inviter: null,
      exhId: '',
      imInfoCard:false,
      imInfo:{},
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },

  computed: {
    ...mapState(['exhibitorDialogVisible', 'receivingUser', 'chatEmployeeList', 'receiver']),
    ...mapGetters(['language', 'inviteType', 'isLogin', 'isTIM'])
  },

  mounted() {},

  methods: {
    // 打开卡片
    showCard(item){
      let params = {
        easemobAccount: item.easemobAccount,
        languageType: this.language == 'en' ? 'EN' : 'CN'
      }
      getUserInfoByEasemob(params).then((res)=>{
        this.imInfo = res.data.data
        this.imInfoCard = true
      })
    },
    // 清空逻辑
    handleClose() {
      this.inviter = null
      this.$store.commit('setReceiver', '')
      this.$store.commit('toogleExhibitorDialog')
      this.$store.commit('setChatEmployeeList', [])
      this.imInfoCard = false
    },
    // 关闭卡片
    closeCard() {
      this.imInfoCard = false
    },
    // 消息弹窗
    async handleEmployeeClick(item) {
      console.log(item)

      if (this.action === 'chat') {
        await inviteOrIM({
          acceptId: item.id,
          acceptSubjectType: 'ACTOR',
          url:location.href,
          interateType: this.language == 'en' ? 'INTERATE_IM_EN' : 'INTERATE_IM_CN',
          language: this.language
        })

      }
      if (this.action === 'invitation') {
        this.inviter = item
      }
    },
    // 拉取会话列表
    async getUserConversationList(userID) {
        console.log(this.$TIM_EVENT.SDK_READY)
    },


    setReceiver() {
      this.$store.commit('setReceiver', this.inviter)
      this.inviter = null
    },

    goEmployeeList() {
      this.inviter = null
      this.$store.commit('setReceiver', '')
      this.imInfoCard = false
    },

    invite(id, index, type) {
      this.inviter = null
      this.$emit('invite', id, index, type)
    }
  }
}
</script>
<style lang="stylus">
.chat-dialog-with-exhibitor {
  width: 700px;

  .el-dialog__header {
    background-color: $color-main;
    padding: 6px 20px;
    box-sizing: border-box;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__title {
    color: $color-white;
    font-size: 16px;
    line-height: 30px;
  }

  .el-dialog__headerbtn {
    top: 13px;
  }

  .el-dialog__close {
    color: $color-white;
  }

  .member-list {
    width: 600px;
    margin: 0 auto;
    padding: 50px 0;
  }

  .swiper-button-prev, .swiper-button-next {
    color: $color-black;
    outline: none;
    top: 56%;
  }

  .swiper-button-prev:after, .swiper-button-next:after {
    font-size: 20px;
  }

  .member-item {
    cursor: pointer;
    width: 172px;
    height: 206px;
    border-radius: 4px;
    box-shadow: 0px 5px 8px 2px $box-shadow2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    position: relative;
    margin: 20px 10px;
  }

  .member-item .item-avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit cover
  }

  .iconchat {
    position: absolute;
    right: 5px;
    bottom: 5px;
    color: $color-main;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  .chat-title__icon {
    color: $color-white;
    margin-right: 10px;
    cursor: pointer;
  }

  .chat-title__name {
    color: $color-white;
    margin-right: 10px;
    font-size: 14px;
    line-height: 30px;
  }

  .chat-title__avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-left: 30px;
    margin-right: 10px;
  }

  .el-dialog__backbtn {
    position: absolute;
    top: 13px;
    left: 20px;
    padding: 0;
    background: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 16px;
  }

  .el-dialog__backbtn i:hover {
    color: $color-main;
  }
}
.invitationClass {
  height 101px
  .invitationBut{
    display block
    height 30px
  }
  .invitationTitle{
    display block
    margin-top 15px
    .invitationTitleTop{
      font-size 14px
      color $color-white
      padding-bottom 4px
    }
    .invitationTitleBottom{
      font-size 16px
      color $color-white
    }
  }
}
.invitationConcat{
  padding: 6px 20px;
  padding-bottom: 16px;
  box-sizing: border-box;
  .invitationTips{
    outline none
    margin 24px 0
    font-size 16px
    color $color-black-65
  }
  .invitationTipsSapn{
    font-size 14px
    color $color-black-65
    cursor pointer
    &:hover {
      color $color-main
    }
  }
}
.imInfoCard{
  position: absolute;
  width: 240px;
  top: 52px;
  left: 4px;
  z-index: 10;
  background: $color-white;
  border-radius: 5px;
  line-height: 30px;
  padding: 4px 10px 10px 10px;
  text-align: center;
  box-shadow:0 0 10px $color-black-10;
  .chat-title__avatar1 {
    width: 64px;
    height: 64px;
    border-radius: 50%;
  }
  .p1{
    color $color-black-65  
  }
  .p2{
    color $color-black-45  
  }
}
</style>
